import { useGetJobsReportQuery as useGetJobsReport } from '../types'
export default useGetJobsReport
